import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { IMAGE_URL } from "../config/config";
import { useAuth } from "../context/AuthContext";
import "../styles/About.css";
import "../styles/Cart.css";

const Cart = () => {
  const { user } = useAuth();
  const { cartItems, removeCartItem, isLoading } = useCart();
  const navigate = useNavigate();

  if (isLoading) {
    return <div className="text-center py-5">Loading cart...</div>;
  }

  const totalAmount = cartItems.reduce((sum, item) => {
    return sum + Number(item.price || item.coursePrice || 0);
  }, 0);

  const handleCheckout = () => {
    if (!user) {
      navigate("/login", {
        state: { from: "/checkout" }, 
      });
    } else {
      navigate("/checkout");
    }
  };

  return (
    <div>
      <section className="banner_area">
        <div className="banner_inner d-flex align-items-center">
          <div className="overlay bg-parallax"></div>
          <div className="container">
            <div className="banner_content text-center">
              <h2>Cart</h2>
              <div className="page_link">
                <Link to="/">Home</Link>
                <span className="breadcrumb-arrow">→</span>
                <Link to="/cart">Cart</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cart Content */}
      <div className="container my-5">
        {cartItems.length === 0 ? (
          <div className="text-center py-5">
            <h4>Your cart is empty 🛒</h4>
            <Link to="/courses" className="btn btn-theme mt-3">
              Browse Courses
            </Link>
          </div>
        ) : (
          <div className="row">
            {/* Left */}
            <div className="col-lg-8">
              {cartItems.map((item) => {
                const name = item.product_name || item.courseName;
                const price = item.price || item.coursePrice;
                const image = item.image || item.courseImage;

                return (
                  <div
                    key={item.product_id}
                    className="cart-item d-flex align-items-center mb-4 p-3"
                  >
                    <img
                      src={
                        image?.startsWith("http")
                          ? image
                          : `${IMAGE_URL}/uploads/${encodeURIComponent(image)}`
                      }
                      alt={name}
                      className="cart-img"
                    />

                    <div className="ms-3 flex-grow-1">
                      <h6 className="mb-1">{name}</h6>
                      <p className="text-primary fw-bold mb-0">₹ {price}</p>
                    </div>

                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => removeCartItem(item.product_id)}
                    >
                      🗑
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Right */}
            <div className="col-lg-4">
              <div className="order-summary p-4">
                <h5 className="fw-bold mb-3">Order Summary</h5>

                <div className="d-flex justify-content-between mb-2">
                  <span>Subtotal</span>
                  <span>₹ {totalAmount}</span>
                </div>

                <div className="d-flex justify-content-between fw-bold mb-3">
                  <span>Total</span>
                  <span>₹ {totalAmount}</span>
                </div>

                <button
                  className="btn btn-checkout w-100"
                  onClick={handleCheckout}
                >
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cart;
